import React, { Component } from 'react';
import Rodal from 'rodal';
import 'rodal/lib/rodal.css';

import Header from '../../Components/Header/Header';
import TopicCard from '../../Components/TopicCard/TopicCard';
import Banner from '../../Components/Banner/Banner';
import SMPWrapper from '../../Components/SMPWrapper/SMPWrapper';
import CompleteMessage from '../../Components/CompleteMessage/CompleteMessage';

import { withContext } from '../../App';

import './styles.scss';

// Data used for the homepage header
const data = {
  image: 'https://s3-eu-west-1.amazonaws.com/uploads.bbcrewind.co.uk/your-war/CostingCollege01.jpg',
  imagePos: '100% 70%',
  bgColor: '',
  pageTitle: 'Spend it like Stormont'
}

class Home extends Component {
  state = { videoModalOpen: true, completeModalOpen: true }

  toggleVideoModal = (val) => {
    const { videoModalOpen } = this.state;

    this.setState({ videoModalOpen: val || !videoModalOpen });
  }

  closeCompleteModal = () => {
    this.setState({ completeModalOpen: false });
  }

  render() {
    const { topics, markVideoWatched, introVideoWatched, scenariosComplete } = this.props.context;
    const { videoModalOpen, completeModalOpen } = this.state;

    return (
      <React.Fragment>
        <Banner topic={data} showHomeButton={false}></Banner>
        <div className="home-page main-content">
          <div className="col-xs-12">
            <Header>
              <p className="text is-primary mt-2">Public services are under pressure like never before.</p>
              <p className="question">If you were Northern Ireland's Finance Minister, how would you spend the budget?
              <button className="watch-again-button" onClick={() => { markVideoWatched(false); this.toggleVideoModal(true) }}>Watch video again</button>
              </p>
            </Header>
            {
              // Only show the intro video if the user hasn't watched/closed it
              !introVideoWatched && (
                <Rodal className="home-video-modal" visible={videoModalOpen} onClose={() => { markVideoWatched(true); this.toggleVideoModal() }} animation="slideUp">
                  <SMPWrapper toggleModal={() => this.toggleVideoModal()} />
                </Rodal>
              )
            }
            {
              // Show the 'completed experience' modal when all 6 scenarios are complette
              scenariosComplete.length === 6 && (
                <Rodal className="home-complete-modal" visible={completeModalOpen} onClose={() => { this.closeCompleteModal() }} animation="slideUp">
                  <CompleteMessage />
                </Rodal>
              )
            }
            <div className="row">
              <div className="col-xs-12">
                <div className="text utility is-center is-lrg is-bold is-primary mb-2">{`${scenariosComplete.length}/6 scenarios complete`}</div>
              </div>
            </div>
            <div className="row">
              {
                Object.keys(topics).map((topic, index) => {
                  return (
                    <div key={index} className="col-lg-4 col-xs-6 pb-2">
                      <TopicCard topic={topics[topic]} />
                    </div>
                  )
                })
              }
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withContext(Home);
